import React, { useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'components/atoms/modal';
import { Select, Option } from 'components/atoms/select';
import { ByHubspotResourceMap } from '../types';

type AddResourceModalTypes = {
  resources: ByHubspotResourceMap;
  visibility: boolean;
  resourceTypeOptions: Option[];
  resourceTypeStatus: 'idle' | 'error' | 'loading' | 'success';
  creationStatus: 'idle' | 'error' | 'loading' | 'success';
  handleClose: () => void;
  handleSubmit: (selected?: string) => void;
};

export const AddResourceModal = ({
  resources,
  resourceTypeOptions,
  creationStatus,
  resourceTypeStatus,
  visibility,
  handleSubmit,
  handleClose,
}: AddResourceModalTypes) => {
  const [selected, setSelected] =
    useState<{ label: string; value: string } | undefined>(undefined);

  const selectedResources = useMemo(
    () => Object.values(resources)?.map((value) => value.externalResourceType),
    [resources],
  );

  const filteredOptions = useMemo(() => {
    return resourceTypeOptions?.filter(
      (resourceType) =>
        !selectedResources.includes(resourceType.value.toString()),
    );
  }, [resourceTypeOptions, selectedResources]);

  const handleSelection = () => {
    handleSubmit(selected?.value);
  };

  return (
    <Modal
      onOk={handleSelection}
      onCancel={handleClose}
      visible={visibility}
      title={
        <FormattedMessage id="settings.integrations.hubspot.resource_mapping.create.object.modal.title" />
      }
      okButtonProps={{ disabled: resourceTypeStatus === 'loading' }}
      destroyOnClose
    >
      <Select
        autoFocus
        options={filteredOptions}
        isLoading={resourceTypeStatus === 'loading'}
        isDisabled={creationStatus === 'loading'}
        onChange={setSelected}
        value={selected}
        isClearable
      />
    </Modal>
  );
};
